import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=454a163d&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=ts&"
export * from "./TextBox.vue?vue&type=script&lang=ts&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=454a163d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a163d",
  null
  
)

export default component.exports